import React, { useState, useEffect } from "react";
import Play from "../assets/images/PlayBtn.png";

const CursorText = ({ text }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({
        x: e.clientX,
        y: e.clientY + window.scrollY, // Adding scroll offset to the y-coordinate
      });
      setVisible(true); // Make text visible on mouse move
    };

    const handleMouseLeave = () => {
      setVisible(false); // Hide text when mouse leaves the window
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div>
      {visible && (
        <span
          style={{
            position: "absolute",
            width: "80px",
            height: "80px",
            top: position.y - 250, // Slight offset so it doesn't overlap with the cursor
            left: position.x - 150,
            pointerEvents: "none", // Ensures the text doesn't interfere with clicks
            backgroundImage: `url(${Play})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            color: "white",
            padding: "20px 11px",
            fontSize: "22px",
            borderRadius: "50%",
            color: "black",
            fontFamily: "Neue Haas Grotesk Display Pro Roman",
            zIndex: 1000, // Keeps text above other elements
          }}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default CursorText;
